import React, { useEffect, useState, FocusEvent } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import "./InputSelectRequiredwithIdAndIcons.scss";

interface InputSelectRequiredwithIdAndIconsProps {
  id: string;
  label: string;
  onInput: (
    id: string,
    value: string | number,
    isValid: boolean,
    label: string
  ) => void;
  options: { txt: string; id: string | number; icon: string; hl?: boolean }[];
  initialValue?: string | number;
  variant?: "standard" | "filled" | "outlined";
  disabled?: boolean;
  forceError?: boolean;
  trackFocus?: boolean;
  focusHandler?: (
    event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  reset?: boolean;
  resetOnOptionsChange?: boolean;
  updateInitValue?: boolean;
  onChangeHandler?: () => void;
  assetUrl?: boolean;
  isOptional?: boolean;
  placeholder?: string;
}

export const InputSelectRequiredwithIdAndIcons = (
  props: InputSelectRequiredwithIdAndIconsProps
) => {
  const {
    id,
    label,
    onInput,
    options,
    initialValue,
    forceError,
    variant,
    disabled,
    trackFocus,
    focusHandler,
    resetOnOptionsChange,
    reset,
    updateInitValue,
    onChangeHandler,
    assetUrl = false,
    isOptional = false,
    placeholder,
  } = props;
  const [inputValue, setInputValue] = useState(initialValue || "");
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    onInput(
      id,
      inputValue,
      !!inputValue || typeof inputValue === "number",
      label.charAt(0).toUpperCase() + label.slice(1)
    );
  }, [id, inputValue, label, onInput]);

  useEffect(() => {
    if (reset) {
      onInput(id, "", false, label.charAt(0).toUpperCase() + label.slice(1));
      setInputValue("");
      setIsTouched(false);
    }
  }, [reset, id, inputValue, label, onInput]);

  useEffect(() => {
    if (updateInitValue) {
      setInputValue(initialValue);
    }
  }, [initialValue, updateInitValue]);

  useEffect(() => {
    if (
      resetOnOptionsChange &&
      !options
        ?.map((opt) => {
          return opt.id;
        })
        ?.includes(inputValue) &&
      (!!inputValue || typeof inputValue === "number")
    ) {
      setInputValue(initialValue);
      onInput(
        id,
        initialValue,
        !!initialValue,
        label.charAt(0).toUpperCase() + label.slice(1)
      );
    }
  }, [options?.[0], options?.[options?.length - 1], resetOnOptionsChange]);

  const touchHandler = () => {
    setIsTouched(true);
  };

  return (
    <FormControl variant={variant} disabled={disabled}>
      <InputLabel
        variant={variant}
        error={
          ((!inputValue && isTouched && typeof inputValue !== "number") ||
            forceError) &&
          !isOptional
        }
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "5px",
                paddingRight: "5px",
                marginLeft: "-5px",
              }
            : {}
        }
        id={`input-label-${id}`}
      >
        {label.charAt(0).toUpperCase() + label.slice(1)}
      </InputLabel>
      <Select
        variant={variant}
        labelId={`label-${id}`}
        className="input-select-icons"
        error={
          ((!inputValue && isTouched && typeof inputValue !== "number") ||
            forceError) &&
          !isOptional
        }
        id={id}
        value={inputValue}
        onBlur={touchHandler}
        onFocus={trackFocus && focusHandler}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setInputValue(event.target.value);
          if (onChangeHandler) {
            onChangeHandler();
          }
        }}
      >
        {options.map((option, i) => {
          return (
            <MenuItem
              className="input-select-icons__item"
              key={option.id + "-option-" + i}
              value={option.id}
            >
              <div className="input-select-icons__item-img-container">
                <img
                  className="input-select-icons__item-img"
                  src={
                    !assetUrl
                      ? !!option.icon
                        ? `${process.env.PUBLIC_URL}/${option.icon}`
                        : `${process.env.PUBLIC_URL}/${
                            placeholder || "azume-logo-gradiente-sm.png"
                          }`
                      : !!option.icon
                      ? `${process.env.REACT_APP_ASSET_URL}/${option.icon}`
                      : `${process.env.PUBLIC_URL}/${
                          placeholder || "azume-logo-gradiente-sm.png"
                        }`
                  }
                  alt={option.txt}
                />
              </div>
              <p
                className={`input-select-icons__item-txt ${
                  option?.hl ? "input-select-icons__item-txt--hl" : ""
                }`}
              >
                {option.txt}
              </p>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
